export default __webpack_public_path__ + "static/media/7.White_Rabbit.d66eecbf.wav";